<template>
  <ap-chip-tabs v-if="tabs.length" v-model:active-key="activeKey" :tabs="tabs" />
</template>

<script setup>
import { computed } from "vue"
import { useI18n } from "vue-i18n"
import { useRoute, useRouter } from "vue-router"
import { HEADER_TYPE } from "@/interfaces/header"
import { useAbility } from "@casl/vue"

const { t } = useI18n()
const route = useRoute()
const router = useRouter()

const ability = useAbility()

const activeKey = computed({
  get: () => route.name,
  set: (value) => {
    router.push({ name: value })
  }
})

const tabs = computed(() => {
  const tabConfig = {
    [HEADER_TYPE.ACCOUNT]: [{ key: "account", tab: t("navigation.account.label") }],
    [HEADER_TYPE.SETTINGS]: [
      { key: "people", tab: t("settings.people.tab.label") },
      { key: "settings", tab: t("settings.settings.tab.label") },
      { key: "billing", tab: t("settings.billing.tab.label") },
      { key: "whitelabel", tab: t("settings.domains.tab.label") },
      { key: "single-sign-on", tab: t("settings.sso.title") }
    ],
    [HEADER_TYPE.STATS]: [{ key: "qr-stats", tab: t("Stats Overview") }]
  }

  return tabConfig[route.meta?.headerType].filter((tab) => ability.can("read", tab.key))
})
</script>
